import { FC } from "react";
import { Breadcrumb } from "antd";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

type Props = {
  label?: string;
};

const OrderDetailsHeaderWeb: FC<Props> = ({ label }) => {
  const { t } = useTranslation();
  const { module } = useParams();

  return (
    <Breadcrumb
      className="font-semibold!"
      classNames={{
        item: "flex! items-center!",
      }}
      items={[
        {
          title: <Link to="/history">{t(`UserHistory.orderDetails.moduleOrders.${module}`)}</Link>,
        },
        {
          title: <div className="font-bold!">{label}</div>,
        },
      ]}
    />
  );
};

export default OrderDetailsHeaderWeb;
